module.exports = "/_next/static/images/icon-coin-8c635f9b.png";